import React, { useState, useEffect, useRef } from "react"
import { DayPicker } from "react-day-picker"
import { format } from "date-fns"
import { cn } from "../../utils/cn"
import { Button } from "./button"

const DatePicker = ({ 
  date, 
  setDate, 
  className, 
  placeholder = "Select date", 
  format: dateFormat = "PPP",
  disabled = false
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef(null)

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [ref])

  const handleSelect = (selectedDate) => {
    setDate(selectedDate)
    setIsOpen(false)
  }

  // Define weekend days (0 is Sunday, 6 is Saturday)
  const isWeekend = (date) => {
    const day = date.getDay();
    return day === 0 || day === 6;
  };

  // Custom modifiers for the DayPicker
  const modifiers = {
    weekend: isWeekend
  };

  // Custom styles for the modifiers
  const modifiersStyles = {
    weekend: {
      color: "#f87171", // This is a red color (Tailwind's red-400)
      fontWeight: "500"
    }
  };

  return (
    <div className={cn("relative", className)} ref={ref}>
      <Button
        variant="outline"
        className={cn(
          "w-full justify-start text-left font-normal",
          !date && "text-muted-foreground"
        )}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
      >
        {date ? format(date, dateFormat) : placeholder}
      </Button>
      {isOpen && (
        <div className="absolute top-12 left-0 z-10 bg-background border rounded-md shadow-md p-3">
          <DayPicker
            mode="single"
            selected={date}
            onSelect={handleSelect}
            initialFocus
            modifiers={modifiers}
            modifiersStyles={modifiersStyles}
            className="p-2"
          />
        </div>
      )}
    </div>
  )
}

DatePicker.displayName = "DatePicker"

export { DatePicker }